module.exports = __webpack_public_path__ + "img/298.2b70b5d9.png";